import {
  BookmarkIcon as BookmarkIconOutline,
  BookmarkIcon,
} from '@heroicons/react/24/solid';
import React from 'react';

export const BookmarkButton = ({
  toggleBookmark,
  bookmarkCount,
  bookmarked,
}) => {
  return (
    <button
      onClick={toggleBookmark}
      className="flex items-center bg-white bg-opacity-80 px-2 py-1 rounded shadow cursor-pointer ml-auto"
    >
      {/* {bookmarkCount > 0 && (
        <span className="text-[11px] text-gray-500 font-normal">({bookmarkCount})</span>
      )} */}
      {bookmarked ? (
        <BookmarkIcon className="w-5 h-5 text-green-600" />
      ) : (
        <BookmarkIconOutline className="w-5 h-5 text-gray-400" />
      )}
    </button>
  );
};
